import Vue from "vue";
import {
  Empty,
  Button,
  Overlay,
  Icon,
  Search,
  Tab,
  Tabs,
  Image,
  Dialog,
  Loading,
} from "vant";
import "@vant/touch-emulator";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/styles/reset.scss";
import "./assets/styles/vant-variable.less";

[
  Empty,
  Button,
  Overlay,
  Icon,
  Search,
  Tab,
  Tabs,
  Image,
  Dialog,
  Loading,
].forEach((component) => Vue.use(component));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
